import React from "react";
import styled from "styled-components";
import TopNav from "./TopNav";

const Main = styled.main`
	padding: calc(var(--lcds-nav-height) + 32px) 32px 48px;
	max-width: ${(p) => (p.$narrow ? "720px" : "1280px")};
	margin: 0 auto;
	@media (max-width: 768px) {
		padding: calc(var(--lcds-nav-height) + 20px) 16px 32px;
	}
`;

const Header = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 24px;
`;

const Titles = styled.div`
	h1 {
		margin: 0;
		font-size: 26px;
		font-weight: 700;
		color: var(--lcds-navy);
		line-height: 1.2;
	}
	p {
		margin: 6px 0 0;
		color: var(--lcds-muted);
		font-size: 14px;
	}
`;

const Actions = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
`;

export const Card = styled.section`
	background: #fff;
	border: 1px solid var(--lcds-border);
	border-radius: 10px;
	padding: ${(p) => p.$padding || "24px"};
	box-shadow: 0 1px 3px rgba(31, 42, 48, 0.06);
`;

/**
 * Standard page frame: fixed top navigation + title row + content.
 *
 * Props: title, subtitle, actions (node), narrow (centers a 720px column, for forms),
 * showLinks (hide the nav links on the login page).
 */
const AppLayout = ({ title, subtitle, actions, narrow = false, showLinks = true, children }) => (
	<>
		<TopNav showLinks={showLinks} />
		<Main $narrow={narrow}>
			{(title || actions) && (
				<Header>
					<Titles>
						{title && <h1>{title}</h1>}
						{subtitle && <p>{subtitle}</p>}
					</Titles>
					{actions && <Actions>{actions}</Actions>}
				</Header>
			)}
			{children}
		</Main>
	</>
);

export default AppLayout;
